import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

export interface GAIANoSpaceRowStyles {
    rowWrapper?: InjectableCss;
    rowContainer?: InjectableCss;
}

const styles: GAIANoSpaceRowStyles = {
    rowWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css`
                        flex-direction: column;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
    rowContainer: {
        css: css`
            width: 50%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    css``,
                    css``,
                ])}
        `,
    },
};

const GAIANoSpaceRow: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.rowWrapper}>
            <StyledWrapper {...styles.rowContainer}>
                <Zone zoneName="Content1" contentId={id} />
            </StyledWrapper>
            <StyledWrapper {...styles.rowContainer}>
                <Zone zoneName="Content2" contentId={id} />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const gAIANoSpaceRow: WidgetModule = {
    component: GAIANoSpaceRow,
    definition: {
        group: "Basic",
    },
};

export default gAIANoSpaceRow;
